import React, { useEffect, useState } from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link, useParams } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'
import { renderLexicalRichText } from '../../../utility/lexical-viewer'
import DOMPurify from 'dompurify';
import { shortenContent, shortenContent10 } from '../../../utility/format-content'
import { Institution, Program } from '../../../core/types/types'
import apiInstance from '../../../utility/apiInstance'
import BackendImage from '../../../core/common/backendImage'
import { getCurrencySymbol } from '../../../utility/currencyUtils'
import { formatPhoneNumber } from '../../../utility/phoneUtils'

const InstitutionDetails = () => {

    const { id } = useParams();
    const [institution, setInstitution] = useState<Institution | null>(null);
    const [programs, setPrograms] = useState<Program[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchInstitution = async () => {
            try {

                const institutionRes = await apiInstance.get(`/api/institutions/${id}`);
                const programsRes = await apiInstance.get(`/api/programs?where[institution][equals]=${id}`);
                setInstitution(institutionRes.data);
                setPrograms(programsRes.data.docs);

            } catch (err) {
                console.error("Failed to fetch institution:", err);
            } finally {
                setLoading(false);
            }
        };

        if (id) fetchInstitution();
    }, [id]);

    if (loading) return <p>Loading...</p>;
    if (!institution) return <p>Institution not found.</p>;

    return (
        <>

            <div className='cs-page-header'>
                <h2>{institution.schoolName}</h2>
                <div className='cs-page-header-content'>
                    <div>{institution.location}</div>
                    <div>{formatPhoneNumber(institution.phoneNumber, institution.country)}</div>
                </div>
            </div>
            <>
                {/* Course detail */}
                <section className="course-details-two">
                    <div className="container">
                        <div className="row mt-4">
                            <div className="col-lg-8">
                                <div>
                                    <BackendImage
                                        src={institution?.image?.url}
                                        alt="img"
                                        className="img-fluid mb-4"
                                    />
                                </div>
                                <div className="course-page-content pt-0">
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <h5 className="mb-3">Overview</h5>
                                            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderLexicalRichText(institution.about)) }} />
                                        </div>
                                    </div>
                                </div>
                                
                                {/* <div className="course-page-content pt-0">
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <h5 className="mb-3">Programs</h5>
                                            <div className="content">
                                                <div className="container">
                                                    <div className="row justify-content-center">
                                                        {programs && programs.map((program: Program) => (
                                                            <div className="col-lg-12">
                                                                <div className="blog">
                                                                    <div className="blog-image">
                                                                        <Link key={program.id}
                                                                            to={all_routes.programDetails.replace(":id", program.id)}>
                                                                            <ImageWithBasePath
                                                                                className="img-fluid"
                                                                                src="./assets/img/blog/blog-16.jpg"
                                                                                alt="img"
                                                                            />
                                                                        </Link>
                                                                    </div>
                                                                    <div className="blog-item">
                                                                        <h5 className="mb-2">
                                                                            <Link key={program.id}
                                                                                to={all_routes.programDetails.replace(":id", program.id)}>
                                                                                {program.programName}
                                                                            </Link>
                                                                        </h5>
                                                                        <p className="text-truncate line-clamb-2">
                                                                            {shortenContent10(program.about || "")}
                                                                        </p>
                                                                        <div className="blog-info">
                                                                            <div className="d-flex align-items-center flex-wrap justify-content-between gap-2">
                                                                                <div className="d-flex align-items-center user-profile">
                                                                                    <h6>{institution.schoolName}</h6>
                                                                                </div>
                                                                                <ul className="d-flex align-items-center flex-wrap gap-2">
                                                                                    <li>
                                                                                        <ImageWithBasePath
                                                                                            className="me-1"
                                                                                            src="./assets/img/icons/calendar.svg"
                                                                                            alt="img"
                                                                                        />
                                                                                        <p>20 Apr 2024</p>
                                                                                    </li>
                                                                                    <li>
                                                                                        <h6 className='text-primary'>{program.applicationFee ? `${getCurrencySymbol(institution.country)}${program.applicationFee}` : "Free"}</h6>
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="row align-items-center">
                                                        <div className="col-md-12">
                                                            <ul className="pagination justify-content-center">
                                                                <li className="page-item prev">
                                                                    <Link className="page-link" to="#" tabIndex={-1}>
                                                                        <i className="fas fa-angle-left" />
                                                                    </Link>
                                                                </li>
                                                                <li className="page-item first-page active">
                                                                    <Link className="page-link" to="#">
                                                                        1
                                                                    </Link>
                                                                </li>
                                                                <li className="page-item">
                                                                    <Link className="page-link" to="#">
                                                                        2
                                                                    </Link>
                                                                </li>
                                                                <li className="page-item">
                                                                    <Link className="page-link" to="#">
                                                                        3
                                                                    </Link>
                                                                </li>
                                                                <li className="page-item next">
                                                                    <Link className="page-link" to="#">
                                                                        <i className="fas fa-angle-right" />
                                                                    </Link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-lg-4">
                                <div className="course-sidebar-sec mt-0">
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <h5 className="subs-title mb-4">Institution Details</h5>
                                            <p className="mb-3">
                                                Founded: {institution.founded}
                                            </p>
                                            <p className="mb-3">
                                                Institution Type: {institution.schoolType}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* /Course detail */}
            </>

        </>
    )
}

export default InstitutionDetails;
